module.exports = "/lucky-balls/img/jackpot/003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/003.png
// module id = 1103
// module chunks = 0